import { render, staticRenderFns } from "./PricingFAQAccordion.vue?vue&type=template&id=20861f93&scoped=true&"
import script from "./PricingFAQAccordion.vue?vue&type=script&lang=js&"
export * from "./PricingFAQAccordion.vue?vue&type=script&lang=js&"
import style0 from "./PricingFAQAccordion.vue?vue&type=style&index=0&id=20861f93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20861f93",
  null
  
)

export default component.exports